import { useEffect, useRef } from 'react';

export function useInjection(injection: () => HTMLElement): HTMLElement | undefined {
    const element = useRef<HTMLElement>();

    useEffect(() => {
        element.current = injection();
    }, [injection]);
    return element.current;
}
